import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UnsubscribeContactFromAllAudiences as UnsubscribeContactFromAllAudiencesMutation,
    UnsubscribeContactFromAllAudiencesVariables,
} from 'nutshell-graphql-types';

import UNSUBSCRIBE_FROM_ALL_AUDIENCES from '../mutations/unsubscribe-contact-from-all-audiences.graphql';

export function useUnsubscribeContactFromAllAudiences(): {
    unsubscribeFromAllAudiences: (
        variables: UnsubscribeContactFromAllAudiencesVariables
    ) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [unsubscribeFromAllAudiences, {loading, error}] = useMutation<
        UnsubscribeContactFromAllAudiencesMutation,
        UnsubscribeContactFromAllAudiencesVariables
    >(UNSUBSCRIBE_FROM_ALL_AUDIENCES);

    return {
        unsubscribeFromAllAudiences: (variables: UnsubscribeContactFromAllAudiencesVariables) =>
            unsubscribeFromAllAudiences({variables}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
